module.exports = __webpack_public_path__ + "img/vuzes.94b68e0a.svg";